import PropTypes from "prop-types";

export const _Forms = {
  formId: PropTypes.number,
};

export const _SelectedForm = {
  formId: PropTypes.number,
  setMessage: PropTypes.func,
};

export const SelectedFormPropTypes = _SelectedForm;

export const FormsPropTypes = _Forms;
